import Decimal from 'decimal.js'

import { fetchRemitanoRate } from '@/utils/apis/helper'
import { CustomTokenInfo } from '@/utils/helpers'

export const DAY_IN_SECONDS = 60 * 60 * 24

type RateData = Awaited<ReturnType<typeof fetchRemitanoRate>> | undefined
export const calculatePoolApr = ({
  fee24h,
  totalLiquidity,
  reward24h,
  rateData,
  rewardTokenInfo,
}: {
  fee24h: Decimal,
  totalLiquidity: number,
  reward24h: Decimal | null,
  rateData: RateData,
  rewardTokenInfo: CustomTokenInfo | null,
}) => {
  if (!totalLiquidity) return new Decimal(0)

  const tokenSymbol = rewardTokenInfo?.symbol.toUpperCase()

  const tokenRate: number = rateData?.[tokenSymbol as keyof RateData] || 0
  const reward24hInUsd = reward24h?.mul(tokenRate) || new Decimal(0)

  // ((24h reward + 24h fee) / total liquidity) * 365
  return reward24hInUsd.plus(fee24h).div(totalLiquidity).mul(365).mul(100)
}
